import { render, staticRenderFns } from "./PaymentTransferChargeTypeChangeModal.vue?vue&type=template&id=726a0799"
import script from "./PaymentTransferChargeTypeChangeModal.vue?vue&type=script&lang=js"
export * from "./PaymentTransferChargeTypeChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports